import { useEffect, useState } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [showBanner, setShowBanner] = useState(false);
  const [notifAsked, setNotifAsked] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('wa_install_dismissed');

    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e as BeforeInstallPromptEvent);
      if (!dismissed) {
        setShowBanner(true);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    await deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowBanner(false);
    askNotificationPermission();
  };

  const askNotificationPermission = () => {
    if (notifAsked) return;
    setNotifAsked(true);
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('wa_install_dismissed', '1');
    askNotificationPermission();
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-96 z-50 bg-background-100 border border-background-300 rounded-2xl shadow-xl p-4 flex items-start gap-3">
      <img
        src="https://static.readdy.ai/image/4348d35aef10b02e64c1a80f787cca17/52f74c8d2b3c4f047b22c4e6b94b8b4b.jpeg"
        alt="WorldApeiron"
        className="w-10 h-10 rounded-lg object-contain shrink-0"
      />
      <div className="flex-1">
        <p className="text-sm font-semibold text-foreground-50">Installer WorldApeiron</p>
        <p className="text-xs text-foreground-400 mt-0.5">
          Ajoutez l'application à votre écran d'accueil pour un accès plus rapide.
        </p>
        <div className="flex items-center gap-3 mt-3">
          <button
            onClick={handleInstall}
            className="text-xs font-semibold bg-primary-500 text-white px-3 py-1.5 rounded-full"
          >
            Installer
          </button>
          <button
            onClick={handleDismiss}
            className="text-xs text-foreground-400"
          >
            Plus tard
          </button>
        </div>
      </div>
    </div>
  );
}

export default InstallPrompt;
